/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Danger_ZoneInputs */



/**
* | output |
* | --- |
* | "Danger zone" |
*
* @param {Team_Manager_Danger_ZoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_danger_zone = /** @type {((inputs?: Team_Manager_Danger_ZoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Danger_ZoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Zone sensible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gefahrenbereich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Zona pericolosa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опасная зона")
	if (locale === "es") return /** @type {LocalizedString} */ ("Zona de peligro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("危险操作")
	if (locale === "ja") return /** @type {LocalizedString} */ ("危険な操作")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खतरनाक क्षेत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Zona de perigo")
	return /** @type {LocalizedString} */ ("Danger zone")
});